import { useEffect, useState } from "react";

// Shared start time so every timer on the page stays in sync.
const START = Date.now();

export function useLoopingCountdown(totalSeconds: number) {
  const compute = () => {
    const elapsed = Math.floor((Date.now() - START) / 1000);
    return totalSeconds - (elapsed % totalSeconds);
  };

  const [remaining, setRemaining] = useState<number>(compute);

  useEffect(() => {
    const id = window.setInterval(() => setRemaining(compute()), 250);
    return () => window.clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [totalSeconds]);

  const safe = remaining >= totalSeconds ? totalSeconds : remaining;
  const hours = Math.floor(safe / 3600);
  const minutes = Math.floor((safe % 3600) / 60);
  const seconds = safe % 60;

  return { hours, minutes, seconds };
}
